import { render, staticRenderFns } from "./DefaultLogo.vue?vue&type=template&id=5414874a&scoped=true&"
import script from "./DefaultLogo.vue?vue&type=script&lang=js&"
export * from "./DefaultLogo.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLogo.vue?vue&type=style&index=0&id=5414874a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5414874a",
  null
  
)

export default component.exports